export default "__VITE_PUBLIC_ASSET__7e2c1f71__"